const apiList = {
    auth: {
        signUp: {
            moodle_method: 'local_webapi_signup_user',
            method: 'POST'
        },
        resetPassword: {
            moodle_method: 'local_webapi_password_reset',
            method: 'POST'
        },
        signUpSettings: {
            moodle_method: 'auth_email_get_signup_settings',
            method: 'GET'
        },
        confirmUser: {
            moodle_method: 'core_auth_confirm_user',
            method: 'POST'
        },
        loginInAUser: {
            moodle_method: 'local_webapi_login_in_a_user',
            method: 'POST'
        },
        changeUserPassword: {
            moodle_method: 'local_webapi_change_user_password',
            method: 'POST'
        }
    },
    books: {
        getBooks: {
            method: 'POST',
            moodle_method: 'mod_book_get_books_by_courses'
        }
    },
    page: {
        getPagesByCourse: {
            method: "GET",
            moodle_method: 'mod_page_get_pages_by_courses'
        },
        viewPageModule: {
            method: 'POST',
            moodle_method: 'mod_page_view_page'
        }
    },
    examus2: {
        getModInExamus: {
            method: 'GET',
            moodle_method: 'availability_examus2_mod_in_examus2'
        }
    },
    forum: {
        getForumsByCourse: {
            method: 'GET',
            moodle_method: 'mod_forum_get_forums_by_courses'
        },
        canUserAddDiscussion: {
            method: 'GET',
            moodle_method: 'mod_forum_can_add_discussion'
        },
        getForumDiscussions: {
            method: 'GET',
            moodle_method: 'mod_forum_get_forum_discussions'
        },
        createDiscussion: {
            method: 'POST',
            moodle_method: 'mod_forum_add_discussion'
        },
        getDiscussionPosts: {
            method: 'GET',
            moodle_method: 'mod_forum_get_discussion_posts'
        },
        deletePost: {
            method: 'POST',
            moodle_method: 'mod_forum_delete_post'
        },
        createPost: {
            method: 'POST',
            moodle_method: 'mod_forum_add_discussion_post'
        },
        updatePost: {
            method: 'POST',
            moodle_method: 'mod_forum_update_discussion_post',
        },
        viewForum: {
            method: 'POST',
            moodle_method: 'mod_forum_view_forum'
        },
        viewDiscussion: {
            method: 'POST',
            moodle_method: 'mod_forum_view_forum_discussion'
        },
        toggleDiscussFavourite: {
            method: 'POST',
            moodle_method: 'mod_forum_toggle_favourite_state'
        },
        setDiscussionSubState: {
            method: 'POST',
            moodle_method: 'mod_forum_set_subscription_state'
        },
        setDiscussionLockState: {
            moodle_method: 'mod_forum_set_lock_state',
            method: 'POST'
        },
        setDiscussionPinState: {
            moodle_method: 'mod_forum_set_pin_state',
            method: 'POST'
        }
    },
    cert: {
        getCertificates: {
            method: 'GET',
            moodle_method: 'customcertelement_certcode_get_all'
        },
        getCertificate: {
            method: 'GET',
            moodle_method: 'customcertelement_certcode_get_cert'
        }
    },
    notification: {
        getUserMessages: {
            method: 'GET',
            moodle_method: 'core_message_get_messages'
        },
        getPopupNotifications: {
            method: 'GET',
            moodle_method: 'message_popup_get_popup_notifications'
        },
        readAllNotifications: {
            method: 'POST',
            moodle_method: 'core_message_mark_all_notifications_as_read'
        }
    },
    grades: {
        getCourseGrades: {
            moodle_method: 'gradereport_overview_get_course_grades',
            method: 'GET'
        },
        getCourseItemsGrades: {
            moodle_method: 'gradereport_user_get_grade_items',
            method: 'GET'
        }
    },
    files: {
        getMoodleFiles: {
            moodle_method: 'core_files_get_files',
            method: 'GET'
        },
        searchFiles: {
            moodle_method: 'local_webapi_files_search',
            method: 'POST'
        },
        addUserPrivateFiles: {
            moodle_method: 'core_user_add_user_private_files',
            method: 'POST'
        },
        deleteDraftFile: {
            moodle_method: 'core_files_delete_draft_files',
            method: 'POST'
        }
    },
    categories: {
        getAll: {
            method: 'POST',
            moodle_method: 'core_course_get_categories',
        },
        getCategoriesByPage: {
            method: 'POST',
            moodle_method: 'local_webapi_get_categories'
        }
    },
    courses: {
        triggerViewEvent: {
            moodle_method: 'core_course_view_course',
            method: 'POST'
        },
        getRecentCourses: {
            moodle_method: 'core_course_get_recent_courses',
            method: 'GET'
        },
        getAll: {
            moodle_method: 'core_course_get_courses',
            method: 'GET'
        },
        getCategoryByCourses: {
            moodle_method: 'core_course_get_categories',
            method: 'GET'
        },
        getGroupByCourses: {
            moodle_method: 'core_group_get_course_user_groups',
            method: 'GET'
        },
        getCourseFullInfo: {
            moodle_method: 'core_course_get_courses_by_field',
            method: 'GET'
        },
        getCourseContents: {
            moodle_method: 'core_course_get_contents',
            method: 'POST'
        },
        getCourseModule: {
            moodle_method: 'core_course_get_course_module',
            method: 'GET'
        },
        getStarredCourses: {
            moodle_method: 'block_starredcourses_get_starred_courses',
            method: 'GET'
        },
        toggleCourseStar: {
            moodle_method: 'core_course_set_favourite_courses',
            method: 'POST'
        },
        getCourseCompletionStatus: {
            moodle_method: 'core_completion_get_course_completion_status',
            method: 'GET'
        },
        searchCourses: {
            moodle_method: 'core_course_search_courses',
            method: 'POST'
        }
    },
    essay: {
        getEssayInfo: {
            moodle_method: "mod_job_get",
            method: 'GET'
        },
        getEssayAttempts: {
            moodle_method: "mod_job_get_attempts",
            method: 'GET'
        },
        getEssayAttempt: {
            moodle_method: 'mod_job_attempt',
            method: 'GET'
        },
        checkEssayAccess: {
            moodle_method: 'mod_job_access',
            method: 'GET'
        },
        createEssayAttempt: {
            moodle_method: 'mod_job_create_attempt',
            method: 'POST'
        }
    },
    activities: {
        getActivitiesCompletionStatus: {
            moodle_method: 'core_completion_get_activities_completion_status',
            method: 'GET'
        },
        updateActivityCompletionStatus: {
            moodle_method: 'core_completion_update_activity_completion_status_manually',
            method: 'POST'
        }
    },
    glossary: {
        getEntries: {
            moodle_method: 'mod_glossary_get_entries_by_letter',
            method: 'GET'
        },
        getGlossaryCats: {
            moodle_method: 'mod_glossary_get_categories',
            method: 'GET'
        },
        findGlossaryEntries: {
            moodle_method: 'mod_glossary_get_entries_by_search',
            method: 'POST'
        },
        triggerViewEvent: {
            moodle_method: 'mod_glossary_view_glossary',
            method: 'POST'
        }
    },
    resource: {
        getResources: {
            moodle_method: 'mod_resource_get_resources_by_courses',
            method: 'POST'
        },
        viewResource: {
            moodle_method: 'mod_resource_view_resource',
            method: 'POST'
        },
    },
    feedback: {
        getFeedbackQuestions: {
            moodle_method: 'mod_feedback_get_items',
            method: 'POST'
        },
        setViewFeedback: {
            moodle_method: 'mod_feedback_view_feedback',
            method: 'POST'
        },
        launchFeedback: {
            moodle_method: 'mod_feedback_launch_feedback',
            method: 'POST'
        },
        getLastCompletedFeedback: {
            moodle_method: 'mod_feedback_get_last_completed',
            method: 'POST'
        },
        getFeedbackAccessInfo: {
            moodle_method: 'mod_feedback_get_feedback_access_information',
            method: 'POST'
        },
        processFeedback: {
            moodle_method: 'mod_feedback_process_page',
            method: 'POST'
        },
    },
    assign: {
        getSubmissionStatus: {
            moodle_method: 'mod_assign_get_submission_status',
            method: 'POST'
        },
        saveSubmission: {
            moodle_method: 'mod_assign_save_submission',
            method: 'POST'
        },
        getSubmissions: {
            moodle_method: 'mod_assign_get_submissions',
            method: 'POST'
        },
        getAllAssigns: {
            moodle_method: 'mod_assign_get_assignments',
            method: 'POST'
        },
        triggerViewEvent: {
            moodle_method: 'mod_assign_view_assign',
            method: 'POST'
        },
        sentSubmission: {
            moodle_method: 'mod_assign_submit_for_grading',
            method: 'POST'
        }
    },
    calendar: {
        getMonthInfo: {
            moodle_method: 'core_calendar_get_calendar_monthly_view',
            method: 'POST'
        },
        getDayInfo: {
            moodle_method: 'core_calendar_get_calendar_day_view',
            method: 'POST'
        },
        getCalendarEvents: {
            moodle_method: 'core_calendar_get_calendar_events',
            method: 'POST'
        },
        getUpcomingEvents: {
            moodle_method: 'core_calendar_get_calendar_upcoming_view',
            method: 'POST'
        }
    },
    tool: {
        searchCourses: {
            moodle_method: 'tool_moodlenet_search_courses',
            method: 'POST'
        },
        searchUsers: {
            moodle_method: 'tool_dataprivacy_get_users',
            method: 'POST'
        },
        getMobileConfig: {
            moodle_method: 'tool_mobile_get_config',
            method: 'POST'
        },
        getContextid: {
            moodle_method: 'local_webapi_get_contextid',
            method: 'POST'
        }
    },
    enroll: {
        getEnrolledUsers: {
            moodle_method: 'local_webapi_get_enrolled_users',
            method: 'GET'
        },
        getEnrolledCourses: {
            moodle_method: 'core_enrol_get_users_courses',
            method: 'GET'
        },
        getEnrolledCoursesByTime: {
            moodle_method: 'core_course_get_enrolled_courses_by_timeline_classification',
            method: 'POST'
        },
        getEnrolmentsMethods: {
            moodle_method: 'core_enrol_get_course_enrolment_methods',
            method: 'POST'
        },
        getSelfEnrolInfo: {
            moodle_method: 'enrol_self_get_instance_info',
            method: 'POST'
        },
        enrollToCourse: {
            moodle_method: 'enrol_self_enrol_user',
            method: 'POST'
        },
        unEnrollToCourse: {
            moodle_method: 'core_enrol_unenrol_user_enrolment ',
            method: 'POST'
        },
    },
    lesson: {
        getLesson: {
            moodle_method: 'mod_lesson_get_lesson',
            method: 'POST'
        },
        getLessonPages: {
            moodle_method: 'mod_lesson_get_pages',
            method: 'POST'
        },
        getPageContent: {
            moodle_method: 'mod_lesson_get_page_data',
            method: 'POST'
        },
        startLessonAttempt: {
            moodle_method: 'mod_lesson_launch_attempt',
            method: 'POST'
        },
        triggerViewEvent: {
            moodle_method: 'mod_lesson_view_lesson',
            method: 'POST'
        },
        finishAttempt: {
            moodle_method: 'mod_lesson_finish_attempt',
            method: 'POST'
        },
        getAttempts: {
            moodle_method: 'mod_lesson_get_lesson_access_information',
            method: 'POST'
        },
        processPage: {
            moodle_method: 'mod_lesson_process_page',
            method: 'POST'
        },
        getTimer: {
            moodle_method: 'mod_lesson_get_user_timers',
            method: 'POST'
        }
    },

    scorm: {
        getAccessInformation: {
            moodle_method: 'mod_scorm_get_scorm_access_information',
            method: 'GET'
        },
        getAttemptCount: {
            moodle_method: 'mod_scorm_get_scorm_attempt_count',
            method: 'GET'
        },
        getScoes: {
            moodle_method: 'mod_scorm_get_scorm_scoes',
            method: 'GET'
        },
        getUserData: {
            moodle_method: 'mod_scorm_get_scorm_user_data',
            method: 'GET'
        },
        getScormsByCourses: {
            moodle_method: 'mod_scorm_get_scorms_by_courses',
            method: 'GET'
        },
        launchSco: {
            moodle_method: 'mod_scorm_launch_sco',
            method: 'POST'
        },
        view: {
            moodle_method: 'mod_scorm_view_scorm',
            method: 'POST'
        }
    },

    group: {
        getGroupMember: {
            moodle_method: 'core_group_get_group_members',
            method: 'POST'
        }
    },

    user: {
        getProfile: {
            moodle_method: 'local_webapi_get_user_info',
            method: 'POST'
        },
        getUsersList: {
            moodle_method: 'core_user_search_identity',
            method: 'POST'
        },
        getUsersList2: {
            moodle_method: 'core_user_get_users',
            method: 'POST'
        },
        syncCalendar: {
            moodle_method: 'tool_yandexcal_save_token',
            method: 'POST'
        },
        getRelevantUsers: {
            moodle_method: 'core_search_get_relevant_users',
            method: 'POST'
        },
        updateUser: {
            moodle_method: 'core_user_update_users',
            method: 'POST'
        },
        updateUserLocale : {
            moodle_method: 'local_webapi_change_user_locale',
            method: 'POST'
        },
        triggerViewEvent: {
            moodle_method: 'core_user_view_user_profile',
            method: 'POST'
        },
        restorePasswordRequest: {
            moodle_method: 'local_webapi_request_password_reset',
            method: 'POST'
        },
        deleteUserToken: {
            moodle_method: 'local_webapi_delete_token_when_user_logout',
            method: 'POST'
        },
        checkUserIsAdmin: {
            moodle_method: 'local_webapi_checking_user_is_admin',
            method: 'GET'
        },
        checkUserCapability: {
            moodle_method: 'local_webapi_checking_user_capability',
            method: 'POST'
        },
        checkCourseAccess: {
            moodle_method: 'local_webapi_checking_course_access',
            method: 'POST'
        }
    },
    profi: {
        getProfiInfo: {
            moodle_method: "mod_profi_get",
            method: 'POST'
        },
        getStatusAttempt: {
            moodle_method: "mod_profi_get_status_attempt",
            method: 'POST'
        },
        getResults: {
            moodle_method: "mod_profi_get_results",
            method: 'POST'
        },
        startProfiAttempt: {
            moodle_method: "mod_profi_start_attempt",
            method: 'POST'
        },
        clearAttempt: {
            moodle_method: "mod_profi_clear_attempt",
            method: 'POST'
        },
        stopAttempt: {
            moodle_method: "mod_profi_stop_attempt",
            method: 'POST'
        },
        skipCompetence: {
            moodle_method: "mod_profi_skip_competence",
            method: 'POST'
        },
        getQuestion: {
            moodle_method: "mod_profi_get_question",
            method: 'POST'
        },
        setAnswer: {
            moodle_method: "mod_profi_set_answer",
            method: 'POST'
        },
    },
    coderunner: {
        runInSandbox: {
            moodle_method: "qtype_coderunner_run_in_sandbox",
            method: 'POST'
        }
    },
    quiz: {
        getAttemptDataJson: {
            moodle_method: "local_webapi_get_quiz_attempt_data",
            method: 'POST'
        },
        checkCoderunnerAnswer: {
            moodle_method: "local_webapi_quiz_coderunner_test",
            method: 'POST'
        },
        startAttempt: {
            moodle_method: 'mod_quiz_start_attempt',
            method: 'POST'
        },
        getAttemptReview: {
            moodle_method: 'local_webapi_get_quiz_review_data',
            method: 'POST'
        },
        viewQuiz: {
            moodle_method: 'mod_quiz_view_quiz',
            method: 'POST'
        },
        getAttemptData: {
            moodle_method: 'mod_quiz_get_attempt_data',
            method: 'POST'
        },
        saveAttempt: {
            moodle_method: 'mod_quiz_save_attempt',
            method: 'POST'
        },
        getAttemptSummary: {
            moodle_method: 'local_webapi_get_quiz_summary',
            method: 'GET'
        },
        getUserAttempts: {
            moodle_method: 'mod_quiz_get_user_attempts',
            method: 'POST'
        },
        getAttemptAccessInf: {
            moodle_method: 'mod_quiz_get_attempt_access_information',
            method: 'POST'
        },
        processAttempt: {
            moodle_method: 'mod_quiz_process_attempt',
            method: 'POST'
        },
        getUserBestGrade: {
            moodle_method: 'mod_quiz_get_user_best_grade',
            method: 'POST'
        },
        getQuizAccessInformation: {
            moodle_method: 'mod_quiz_get_quiz_access_information ',
            method: 'POST'
        },
        safetyModeFail: {
            moodle_method: 'local_webapi_quiz_safety_mode_fail',
            method: 'POST'
        }
    },
    url: {
        viewURl: {
            moodle_method: 'mod_url_view_url',
            method: 'POST'
        },
        getUrls: {
            moodle_method: 'mod_url_get_urls_by_courses',
            method: 'POST'
        }
    },
    folder: {
        getFolders: {
            moodle_method: 'mod_folder_get_folders_by_courses',
            method: 'POST'
        },
        viewFolder: {
            moodle_method: 'mod_folder_view_folder',
            method: 'POST'
        }
    },
    badges: {
        getUserBadges: {
            moodle_method: 'core_badges_get_user_badges',
            method: 'POST'
        }
    },
    wiki: {
        getWikis: {
            moodle_method: 'mod_wiki_get_wikis_by_courses',
            method: 'POST'
        },
        getWikiMap: {
            moodle_method: 'local_webapi_wiki_get_map',
            method: 'POST'
        },
        editWikiPage: {
            moodle_method: 'mod_wiki_edit_page',
            method: 'POST'
        },
        getWikiPages: {
            moodle_method: 'mod_wiki_get_subwiki_pages',
            method: 'POST'
        },
        createWikiPage: {
            moodle_method: 'mod_wiki_new_page',
            method: 'POST'
        },
        viewWiki: {
            moodle_method: 'mod_wiki_view_wiki',
            method: 'POST'
        },
        getWikiFiles: {
            moodle_method: 'mod_wiki_get_subwiki_files',
            method: 'POST'
        },
        getAvailableSubwikis: {
            moodle_method: 'mod_wiki_get_subwikis',
            method: 'POST'
        },
        getWikiComments: {
            moodle_method: 'core_comment_get_comments',
            method: 'POST'
        },
        addWikiComment: {
            moodle_method: 'core_comment_add_comments',
            method: 'POST'
        },
        getWikiHistory: {
            moodle_method: 'local_webapi_wiki_get_history',
            method: 'POST'
        }
    },
    comments: {
        deleteComment: {
            moodle_method: 'core_comment_delete_comments',
            method: 'POST'
        }
    },
    questionnaire: {
        getQuestionnaireById: {
            moodle_method: 'local_jquestionnaire_get_questionnaire_data',
            method: 'POST'
        },
        submitQuestionnaireResponse: {
            moodle_method: 'mod_questionnaire_submit_questionnaire_response',
            method: 'POST'
        }
    },
    payedcourses: {
        getCourseInfo: {
            method: 'POST',
            action: 'web/getcoursesinfo'
        },
        getUserContract: {
            method: 'POST',
            action: 'web/getcontract'
        },
        getUserContractExtendedInfo: {
            method: 'POST',
            action: 'web/getcontractextendedinfo'
        },
        getUserContractPrint: {
            method: 'POST',
            action: 'web/printcontract.pdf'
        },
        signUserContract: {
            method: 'POST',
            action: 'web/signcontract'
        },
        registerContract: {
            method: 'POST',
            action: 'web/usercontract'
        },
        addDiplomToContract: {
            method: 'PUT',
            action: 'web/usercontract'
        },
        addUserinfoToContract: {
            method: 'POST',
            action: 'web/userinfo'
        },
        getPaymentLink: {
            method: 'POST',
            action: 'payment/pay/utmn'
        },
        getFeedbackHealth: {
            method: 'GET',
            action: 'ping'
        }
    },
    customizing: {
        getCustomInfo: {
            moodle_method: 'local_email_get_custom_info',
            method: 'GET'
        }
    },
    yandex: {
        getChatInfo: {
            moodle_method: 'mod_yandexchat_info_chat',
            method: 'GET'
        }
    },
    aidocscanner: {
        analyzeImageByFile: {
            method: 'POST',
            handler: 'aidocscanner/classify_by_file'
        },
        getPreviousPrediction: {
            method: 'POST',
            handler: 'aidocscanner/get_previous_prediction'
        }
    }
}



export {apiList}
